import { z } from "zod";
import { apiOSS as api, buildAuthHeaders } from "./apiOSS";

export const settingsSchema = z.object({
  id: z.string(),
  webhookUrl: z.string().nullable(),
  webhookKey: z.string().nullable(),
});
export type Settings = z.infer<typeof settingsSchema>;

const SETTINGS_URL = `/settings`;

export async function getSettings(apiKey: string): Promise<Settings | null> {
  const authHeaders = await buildAuthHeaders(apiKey);
  const resp = await api.get(SETTINGS_URL, authHeaders);
  return resp.data ? settingsSchema.parse(resp.data) : null;
}

export const settingsUpdateSchema = z.object({
  webhookUrl: z.string().url().optional().or(z.literal("")),
});
export type SettingsUpdate = z.infer<typeof settingsUpdateSchema>;

export async function updateSettings(payload: SettingsUpdate, apiKey: string): Promise<Settings> {
  const authHeaders = await buildAuthHeaders(apiKey);
  const resp = await api.post(SETTINGS_URL, payload, authHeaders);
  if (!resp.data) throw new Error(`Update didn't return Settings`);
  return settingsSchema.parse(resp.data);
}

export default api;
